// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"be11cb8e","58":"6cdc479b","96":"89fff2e2","104":"2eccbce6","181":"1009ad97","267":"c1fd497c","329":"7990f91e","479":"efb82ed1","490":"076e6706","522":"afba6752","629":"05f72669","693":"44cf193d","764":"03ba8922","836":"61109726","910":"27eb719d"}[chunkId] + ".chunk.js";
};